import React from 'react';

import { Box, Logo, tokens } from '@iclinic/design-system';
import {
  ChatBubble,
  CheckIcon,
  FooterGrid,
  SignupBody,
  SignupInfoContainer,
  SignupInfoItem,
  SignupInfoList,
} from './SignupInfo.styles';
import { singupBenefits } from '../constants';

const SingleSignupInfo = () => {
  return (
    <SignupInfoContainer>
      <Box mb={tokens.spacing.md}>
        <Logo color={Logo.Colors.Blue} width={176} showName />
      </Box>
      <Box mb={tokens.spacing.sm}>
        <SignupBody variant="xs">
          O iClinic é o software médico em nuvem{' '}
          <strong>líder de mercado do Brasil.</strong>
          <br />
          Melhor do que falar dos nossos diferenciais, é você testar, na
          prática, tudo que podemos oferecer para seus atendimentos e a gestão
          da sua clínica.
        </SignupBody>
      </Box>
      <Box mb={tokens.spacing.md}>
        <SignupBody variant="xs" bold>
          Faça nosso teste gratuito por 5 dias sem nenhum compromisso e conheça
          nossas soluções:
        </SignupBody>
      </Box>
      <SignupInfoList>
        {singupBenefits.map((benefit) => (
          <SignupInfoItem key={benefit}>
            <CheckIcon />
            <SignupBody variant="xs">{benefit}</SignupBody>
          </SignupInfoItem>
        ))}
      </SignupInfoList>
      <FooterGrid>
        <ChatBubble />
        <SignupBody variant="xs">
          Preencha seu cadastro para iniciar o teste. Não pedimos dados do
          cartão e nosso suporte tira suas dúvidas em{' '}
          <strong>até 5 minutos,</strong> durante o horário comercial, pelo chat
          dentro do sistema.
        </SignupBody>
      </FooterGrid>
    </SignupInfoContainer>
  );
};

export default SingleSignupInfo;
